import { createSlice } from "@reduxjs/toolkit";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import getReducersLayout from "../utils/getReducersLayout";

// Actual Initial State
const initialState: PhantomWalletAdapter | null = null;

const walletSlice = createSlice({
  initialState,
  name: "wallet",
  reducers: {
    ...getReducersLayout<PhantomWalletAdapter | null>(initialState),
  },
});

export const { setData, resetData } = walletSlice.actions;
export default walletSlice;
